import { SpinnerWrapper, StyledSpinner } from 'components/table/SubmissionTableSpinnerStyles';

const SubmissionTableSpinner = ({ className = '' }) => (
  <SpinnerWrapper className={className}>
    <StyledSpinner />
  </SpinnerWrapper>
);

export default SubmissionTableSpinner;
